import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useStaticQuery, graphql, Link } from 'gatsby'
import { useEventListener } from 'react-recipes'
import { ProfileResident } from '~/icons/ProfileResident'
import { ProfileCompany } from '~/icons/ProfileCompany'
import { ChevronDown } from '~/icons/ChevronDown'
import trads from '~/intl/trads.json'
import transformLink from '~/utils/transformLink'
import { setHasFixedProfileNav } from '~/store/actions'
import slugify from 'slugify'

const ProfileNav = ({ title, profilePage = false }) => {
  const lang = useSelector((state) => state.lang)
  const isFixed = useSelector((state) => state.hasFixedProfileNav)

  const dispatch = useDispatch()

  const [isOpen, setIsOpen] = useState(false)
  const [currentProfile, setCurrentProfile] = useState(null)
  const [bgColor, setbgColor] = useState(null)
  const [textColor, setTextColor] = useState('white')
  const [icon, setIcon] = useState(null)
  const [iconHeight, setIconHeight] = useState(null)

  let container = React.createRef()
  let profileSelectWrap = React.createRef()
  let profileSelectList = React.createRef()

  const datas = useStaticQuery(graphql`
    query {
      profiles: allContentfulProfile(
        filter: {
          distributionChannel: { elemMatch: { title: { eq: "Site internet" } } }
        }
      ) {
        nodes {
          title
          type
          node_locale
          navLinks {
            pageLink {
              ... on Node {
                ... on ContentfulDatasOdre {
                  ...ContentfulDatasOdreFields
                  mainImage {
                    ...ContentfulMainImageDetailsFields
                  }
                }
                ... on ContentfulEvent {
                  ...ContentfulEventFields
                  mainImage {
                    ...ContentfulMainImageDetailsFields
                  }
                }
                ... on ContentfulNews {
                  ...ContentfulNewsFields
                  mainImage {
                    ...ContentfulMainImageDetailsFields
                  }
                }
                ... on ContentfulPage {
                  ...ContentfulPageFields
                  mainImage {
                    ...ContentfulMainImageDetailsFields
                  }
                }
                ... on ContentfulContact {
                  ...ContentfulContactFields
                  mainImage {
                    ...ContentfulMainImageDetailsFields
                  }
                }
                ...ContentfulProfileFields
                ... on ContentfulProfile {
                  ...ContentfulProfileFields
                }
                ... on ContentfulGovernance {
                  ...ContentfulGovernanceFields
                  mainImage {
                    ...ContentfulMainImageDetailsFields
                  }
                }
                ... on ContentfulAction {
                  ...ContentfulActionFields
                  mainImage {
                    ...ContentfulMainImageDetailsFields
                  }
                }
                ... on ContentfulProject {
                  ...ContentfulProjectFields
                  mainImage {
                    ...ContentfulMainImageDetailsFields
                  }
                }
                ...ContentfulLaboFields
                ...ContentfulMapFields
                ...ContentfulHubFields
                ...ContentfulNewsroomListFields
              }
            }
            label
            customLink
          }
        }
      }
    }
  `)

  const handleScroll = () => {
    let headerHeight = document.querySelector('.header__content').offsetHeight

    let offset = 0
    let parentOffset

    if (container.current !== null) {
      if (
        container.current.parentNode.parentNode.offsetTop ===
        container.current.parentNode.offsetTop
      ) {
        parentOffset = container.current.parentNode.parentNode.offsetTop
      } else {
        if (profilePage) {
          parentOffset = 0
        } else {
          offset = 40
          parentOffset =
            container.current.parentNode.parentNode.offsetTop +
            container.current.parentNode.offsetTop
        }
      }

      if (
        headerHeight + window.pageYOffset >=
        container.current.offsetTop + parentOffset - offset
      ) {
        dispatch(setHasFixedProfileNav(true))
      } else {
        dispatch(setHasFixedProfileNav(false))
      }
    }
  }

  useEventListener('scroll', handleScroll)

  const iconClassname = {
    className: 'profile-nav__icon',
    width: '68',
    height: { iconHeight },
  }

  useEffect(() => {
    dispatch(setHasFixedProfileNav(false))

    document.addEventListener('click', (e) => {
      if (
        !e.target.classList.contains('.profile-nav-select') &&
        e.target.closest('.profile-nav-select') === null
      ) {
        setIsOpen(false)
      }
    })

    datas.profiles.nodes.forEach((item) => {
      if (item.node_locale === lang && item.title === title) {
        setCurrentProfile(item)

        switch (item.type) {
          case 'Riverain':
            setbgColor('lighter-blue-profile')
            setIcon(<ProfileResident {...iconClassname} />)
            setIconHeight(70)
            setTextColor('purple')
            break
          case 'Entreprise':
            setbgColor('lighter-green')
            setIcon(<ProfileCompany {...iconClassname} />)
            setIconHeight(76)
            break
          case 'Investisseur':
            setbgColor('green')
            setIcon(<ProfileCompany {...iconClassname} />)
            setIconHeight(76)
            break
          case 'Collectivité':
            setbgColor('medium-purple-2')
            setIcon(<ProfileCompany {...iconClassname} />)
            setIconHeight(76)
            break
          default:
            break
        }
      }
    })
  }, [dispatch, datas, lang, title])

  return (
    <>
      {currentProfile !== null && bgColor !== null && (
        <div className="w-full" ref={container}>
          <div className={`profile-nav ${isFixed ? 'is-fixed' : ''}`}>
            <div className="fluid-grid">
              <div className="col-12 lg-col-10 xl-col-7 mx-auto xl-col-offset-2">
                <div
                  className={`profile-nav__inner profile-nav__inner--${bgColor} relative bg-${bgColor}`}
                >
                  {icon}
                  <p
                    className={`profile-nav__title text-${textColor} lg:flex-shrink-0`}
                  >
                    {lang === 'fr'
                      ? `${trads[lang].profile.profile} ${currentProfile.title} :`
                      : `${currentProfile.title} ${trads[lang].profile.profile}:`}
                  </p>
                  <div className="profile-nav-select flex-shrink-0 md:ml-8">
                    <button
                      className={`profile-nav-select__toggle ${isOpen ? 'is-open' : ''}`}
                      onClick={() => setIsOpen(!isOpen)}
                    >
                      {trads[lang].profile.selectPage}

                      <ChevronDown
                        className="ml-4 flex-shrink-0"
                        width="24"
                        height="24"
                      />
                    </button>
                    <div
                      className={`profile-nav-select__list ${isOpen ? 'is-visible' : ''}`}
                    >
                      <div
                        ref={profileSelectWrap}
                        className="profile-nav-select__list-wrap"
                      >
                        <ul ref={profileSelectList}>
                          {currentProfile.navLinks.map((link, i) => {
                            let { url, contentTypeContentful } = transformLink(
                              link,
                              true,
                              false,
                            )
                            if (
                              link.pageLink?.internal?.type ===
                              'ContentfulNewsroomList'
                            ) {
                              url = `${url}/${slugify(title, { lower: true })}`
                            }

                            return (
                              <li key={i}>
                                {contentTypeContentful !==
                                'ContentfulSimulator' ? (
                                  <Link
                                    className="profile-nav-select__link"
                                    to={url}
                                  >
                                    {link.label}
                                  </Link>
                                ) : (
                                  <a
                                    className="profile-nav-select__link"
                                    href={url}
                                  >
                                    {link.label}
                                  </a>
                                )}
                              </li>
                            )
                          })}
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default ProfileNav
